import {
  Component,  OnInit,
  EventEmitter,
  Output,
  Input,
  OnChanges,
  ChangeDetectionStrategy
} from '@angular/core';

import { GridExportData } from '../../services/grid/grid.service';
import { DownloadsService } from '../../services/downloads/downloads.service';
import { TasksService } from '../../services/tasks/tasks.service';

@Component({
  selector: 'bdr-reload-logs-cnmc-options',
  templateUrl: './bdr-reload-logs-cnmc-options.component.html',
  styleUrls: ['./bdr-reload-logs-cnmc-options.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class BdrReloadLogsCNMCOptionsComponent implements OnChanges {
  @Input() appliedFilters: any = [];
  @Input() visibleColumns = [];
  @Input() allColumns = [];
  @Input() exportData: GridExportData[];
  @Output() close: EventEmitter<Function> = new EventEmitter<Function>();

  isFilter: boolean = false;

  constructor(   
    private tasksService: TasksService,
  ) { }

  ngOnChanges() { 
    this.isFilter = this.appliedFilters.length > 0; 
  }

  closePanel() {
    this.close.emit();
  }

  reloadCNMCValidations() {
    this.tasksService.reloadSheet('cnmc-validations');
  }


  reloadFormCnmcValidations() {
    this.tasksService.reloadFormCnmcValidations(this.exportData[0].origin);
  }


  reloadCNMCErrorLogs() {
    this.tasksService.reloadSheet('cnmc-logs');
  }

  reloadFormCnmcErrorLogs() {
    this.tasksService.reloadFormCnmcErrorLogs(this.exportData[0].origin);
  }

  groupedForms() {
    return [
      'fb1at_vista',
      'fb1bt_vista',
      'fb1mt_vista',

      'fb1_1at_vista',
      'fb1_1bt_vista',
      'fb1_1mt_vista',

      'fb7atmt_vista',
      'fb7bt_vista'
    ].includes(this.exportData[0].origin);
  }
}
